import { type FC, useMemo } from "react";

export interface NumberFormatterProps {
  value: number;
}

export const NumberFormatter: FC<NumberFormatterProps> = (props) => {
  const formatter = useMemo(() => new Intl.NumberFormat("en-US"), []);

  return formatter.format(props.value);
};
